// extracted by mini-css-extract-plugin
export var externalIcon = "LGk7m_7ZbzVL5NMmKV64";
export var focusVisible = "dCSB3JQj3PY6XSIlTlS5";
export var inherit = "yC6Q3D3Fkh7JJGqwqynW";
export var interfaceIcon = "g859qfqWJLezXNhuXUd2";
export var root = "TcsEBM6ZtKxU4M5sCNpw";